import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 323.77 90.49"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 2" }, [
  /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 1" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M306.56 2H73.22C65 2 57.91 8.31 57.55 16.52a15.21 15.21 0 0 0 15.19 15.9A12.57 12.57 0 0 1 85.32 45v.51a12.58 12.58 0 0 1-12.58 12.57H17.68C9.47 58.08 2.38 64.39 2 72.6a15.2 15.2 0 0 0 15.21 15.89H251c8.21 0 15.3-6.31 15.66-14.51a15.2 15.2 0 0 0-15.19-15.9h-3.58a12.58 12.58 0 0 1-12.62-12.58V45a12.57 12.57 0 0 1 12.58-12.57h58.23c8.22 0 15.31-6.32 15.67-14.52A15.2 15.2 0 0 0 306.56 2Z",
      "data-name": "Clouds",
      style: {"fill":"#fff7f3","stroke":"#2d2d34","stroke-miterlimit":"10","stroke-width":"2px"}
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }